<adaa-data-table
    #adaaDataTable
    apiName="getLookupContentList"
    [titleHeader]="displayTitle()"
    [configKey]="constants.MAIN_TABLE_LIST_CONF_KEY.LOOKUPCONTENT"
    [paramsString]="lookupId"
    [itemTypeId]="constants.CONSTANT_PERMISSIONS.LOOKUP_MANAGEMENT"
    [enableAdd]="true"
    [enableEditAction]="true"
    [enableDeleteAction]="true"
    [enableViewAction]="true"
    [enablePrint]="true"
    [customActionButtons]="customButtons"
    (addNewClicked)="addNew()"
    (actionClicked)="getAction($event)"
></adaa-data-table>

<adaa-lookup-content-editor #editor [pageMode]="pageMode()" (editorClosed)="submit($event)"> </adaa-lookup-content-editor>
